import React from 'react';

import { SceneMenuContent } from '../common/SceneMenuContent';
import { AddItemMenuItem } from '../shared-menu-items/AddItemMenuItem';

export function MovingLoadsContainerMenu() {
  return (
    <SceneMenuContent>
      <AddItemMenuItem type="movingLoad" />
    </SceneMenuContent>
  );
}
